import { ReactNode, ComponentProps } from 'react';
import { withStyles, MaterialSymbol } from 'vopay';
import styles from './Chip.module.scss';

const cn = withStyles(styles);

type IconProps = ComponentProps<typeof MaterialSymbol>;

// Feature-local to ClientAccountList (ID-13350): moved from client-dashboard's UI/Chip, deps rewritten to
// vopay only. Kept internal (relative import, not the shared UI barrel) rather than vopay's own `Chip` —
// the two are different components and the name would clash. Only this feature uses it today.
type ChipProps = {
  disabled?: boolean;
  label: ReactNode;
  onClick?: () => void;
  iconLeft?: IconProps['icon'];
  iconLeftProps?: IconProps;
  iconRight?: IconProps['icon'];
  iconRightProps?: IconProps;
  className?: string;
};

export default function Chip({
  disabled = false,
  label,
  onClick,
  iconRight,
  iconRightProps,
  iconLeft,
  iconLeftProps,
  className,
}: ChipProps) {
  function renderContents() {
    return (
      <>
        {iconLeft && <MaterialSymbol className={cn('icon')} icon={iconLeft} />}
        {iconLeftProps && <MaterialSymbol {...iconLeftProps} className={cn('icon', iconLeftProps.className)} />}
        <div className={cn('label')}>{label}</div>
        {iconRight && <MaterialSymbol className={cn('icon')} icon={iconRight} />}
        {iconRightProps && <MaterialSymbol {...iconRightProps} className={cn('icon', iconRightProps.className)} />}
      </>
    );
  }

  if (onClick && !disabled) {
    return (
      <button className={cn('chip', className)} onClick={onClick}>
        {renderContents()}
      </button>
    );
  }

  return <div className={cn('chip', className)}>{renderContents()}</div>;
}
